/** Conversation starters shown in each category's advisor card. */
export const ADVISOR_PRESETS = {
  horoscope: [
    "What do my stars say today?",
    "Which area should I focus on?",
    "What should I watch out for?",
  ],
  moon: ["What’s today’s moon phase?", "How does the moon affect me?", "Is the moon on my side?"],
  biorhythm: [
    "How are my cycles today?",
    "When am I at my peak?",
    "Body, mind, or heart — what’s strongest?",
  ],
  numerology: ["What’s my number today?", "What does it mean for me?", "How should I use it?"],
  tarot: ["What does my card reveal?", "What should I focus on?", "Any advice for today?"],
  runes: [
    "What does my rune mean?",
    "What is it guiding me toward?",
    "What should I be careful of?",
  ],
} as const
